export enum EmploymentHistoryStatusPrimaryPillColors {
  Leave = '#CC7212',
  Inactive = '#666666',
  Active = '#0D5D4B'
}

export enum EmploymentHistoryStatusSecondaryPillColors {
  Leave = '#FCF6EB',
  Inactive = '#F7F7F7',
  Active = '#E8F3F1'
}
